import React, { useEffect } from "react";
import { Grid } from "semantic-ui-react";
import ProfileHeader from "./ProfileHeader";
import ProfileContent from "./ProfileContent";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useTranslation } from 'react-i18next'; // Add this import for i18n

export default observer( function()
{
    const {userID} = useParams<{userID:string}>(); 
    const{profileStore, commonStore} = useStore();
    const{loadingProfile, profile, loadProfile, setActiveTab} = profileStore;
    const { t } = useTranslation(); // Initialize translation hook

    useEffect(()=>{
        if (commonStore.appLoaded) {
            loadProfile(userID);
        }
        
        return ()=>{
            setActiveTab(0);
        }
    },[commonStore.appLoaded,loadProfile,userID, setActiveTab])

    if (!commonStore.appLoaded) return <LoadingComponent content={t('profilePage.checkingAuth')} />;
    if(loadingProfile) return <LoadingComponent content={t('profilePage.loadingProfile')} />

    return(
       <Grid>
        <Grid.Column width={16}>
        {profile && 
            <>
                <ProfileHeader profile ={profile}/>          
                <ProfileContent profile ={profile}/>
            </>
        }
        </Grid.Column>

        </Grid>
    )
}
)